import React, { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';
const resumeUrl = '/resume/Aniket_Hirpara_Resume.pdf';

export default function Resume() {
  const [pageCount, setPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [readerWidth, setReaderWidth] = useState(760);
  const [error, setError] = useState(false);
  const readerRef = useRef(null);

  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => setReaderWidth(Math.floor(entry.contentRect.width)));
    observer.observe(readerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <main className="resume-page page-width">
      <div className="page-heading"><div><span className="eyebrow"><span className="status-dot mint" /> MOST RECENT RESUME</span><h1>Current resume<span className="pink">.</span></h1><p className="intro">Aniket Hirpara · PDF · Updated September 18, 2026</p></div><a className="primary-link" href={resumeUrl} download>Download PDF ↓</a></div>
      <section className="resume-reader" aria-label="Resume PDF reader">
        <div className="reader-toolbar"><span>ANIKET_HIRPARA_RESUME.PDF</span><a href={resumeUrl} target="_blank" rel="noreferrer">Open original ↗</a></div>
        <div className="pdf-container" ref={readerRef}>
          <Document file={resumeUrl} onLoadSuccess={({ numPages }) => { setPageCount(numPages); setError(false); }} onLoadError={() => setError(true)} loading={<p className="reader-message" role="status">Loading your most recent resume…</p>} error={<p className="reader-message" role="alert">The reader couldn’t load the PDF. <a href={resumeUrl}>Open the resume directly</a>.</p>}>
            <Page pageNumber={pageNumber} width={Math.max(240, readerWidth)} loading={<p className="reader-message" role="status">Rendering page…</p>} />
          </Document>
        </div>
        {!error && pageCount > 0 && <div className="reader-controls"><button disabled={pageNumber === 1} onClick={() => setPageNumber(pageNumber - 1)} aria-label="Previous resume page">← Previous</button><span aria-live="polite">Page {pageNumber} of {pageCount}</span><button disabled={pageNumber === pageCount} onClick={() => setPageNumber(pageNumber + 1)} aria-label="Next resume page">Next →</button></div>}
      </section>
      <p className="fine-print">This is the most recent resume published here. You can read it above or download the original PDF.</p>
    </main>
  );
}
